import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatRadioModule } from '@angular/material/radio';
import { MatButtonModule } from '@angular/material/button';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatCardModule } from '@angular/material/card';
import { MatRippleModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSelectModule } from '@angular/material/select';
import { MatSliderModule } from '@angular/material/slider';
import { MatTooltipModule } from '@angular/material/tooltip';
import { TranslateModule } from '@ngx-translate/core';
import { AgGridModule } from 'ag-grid-angular';
import { HotkeyModule } from 'angular2-hotkeys';

import { SeFabSliderComponent } from '../ecg-viewer-module/ecg-fab-tools/fab-components/se-fab-slider/se-fab-slider.component';
import { LayoutFabSubToolsComponent } from '../ecg-viewer-module/ecg-fab-tools/layout-fab-tools/layout-fab-sub-tools/layout-fab-sub-tools.component';
import { LayoutFabToolsComponent } from '../ecg-viewer-module/ecg-fab-tools/layout-fab-tools/layout-fab-tools.component';
import { GlobalAnnotationsComponent } from '../ecg-viewer-module/measures/annotations/global-annotations/global-annotations.component';
import { LeadsAnnotationsComponent } from '../ecg-viewer-module/measures/annotations/leads-annotations/leads-annotations.component';
import { CaliperComponent } from '../ecg-viewer-module/ecg-chart/caliper/caliper.component';
import { PointerComponent } from '../ecg-viewer-module/ecg-chart/caliper/pointer/pointer.component';
import { WindowComponent } from '../ecg-viewer-module/ecg-chart/caliper/window/window.component';
import { EcgChartComponent } from '../ecg-viewer-module/ecg-chart/ecg-chart.component';
import { LayersCenteringComponent } from '../ecg-viewer-module/ecg-chart/layers-centering/layers-centering.component';
import { StepComponent } from '../ecg-viewer-module/ecg-chart/trace/step/step.component';
import { TraceComponent } from '../ecg-viewer-module/ecg-chart/trace/trace.component';
import { CustomMeasuresComponent } from '../ecg-viewer-module/measures/custom-measures/custom-measures.component';
import { CaliperMeasuresComponent } from '../ecg-viewer-module/measures/caliper-measures/caliper-measures.component';
import { EcgSummaryComponent } from '../ecg-viewer-module/ecg-summary/ecg-summary.component';
import { EcgToolbarComponent } from '../ecg-viewer-module/ecg-toolbar/ecg-toolbar.component';
import { EcgViewerComponent } from '../ecg-viewer-module/ecg-viewer/ecg-viewer.component';
import { FixedFiltersComponent } from '../ecg-viewer-module/fixed-filters/fixed-filters.component';
import { MultiViewerComponent } from '../ecg-multiviewer-module/multiviewer.component';
import { EditableCellComponent } from '../ecg-viewer-module/measures/editable-cell/editable-cell.component';
import { CaliperAndMeasuresComponent } from '../ecg-viewer-module/measures/caliper-and-measures/caliper-and-measures.component';
import { DateTimePipe } from '../ecg-viewer-module/utils/datetime.pipe';
import { SeCheckedItemComponent } from '../ecg-multiviewer-module/se-checkedlistbox/se-checkeditem.component';
import { SeCheckedListBoxComponent } from '../ecg-multiviewer-module/se-checkedlistbox/se-checkedlistbox.component';
import { SeComboBoxComponent } from '../ecg-viewer-module/se-combobox/se-combobox.component';
import { SeImageButtonComponent } from '../ecg-viewer-module/se-imagebutton/se-imagebutton.component';
import { SeSliderButtonComponent } from '../ecg-viewer-module/se-sliderbutton/se-sliderbutton.component';
import { SeStateButtonComponent } from '../ecg-viewer-module/se-statebutton/se-statebutton.component';
import { SeToggleButtonComponent } from '../ecg-viewer-module/se-togglebutton/se-togglebutton.component';
import { SeSpinnerComponent } from '../ecg-viewer-module/se-spinner/se-spinner.component';
import { SeSpriteComponent } from '../ecg-viewer-module/se-sprite/se-sprite.component';
import { SeFullScreenComponent } from '../ecg-viewer-module/se-fullscreen/se-fullscreen.component';
import { SeClickOutsideDirective } from './se-clickoutside.directive';
import { StoreModule } from '@ngrx/store';
import * as fromEcg from '../store/reducers';
import { LayerComponent } from '../ecg-viewer-module/ecg-chart/layer/layer.component';

export { LayerViewModel } from '../ecg-viewer-module/view-models/layer-viewmodel';

@NgModule({
    declarations: [],
    imports: [
        LayerComponent,
        MultiViewerComponent,
        EcgViewerComponent,
        FixedFiltersComponent,
        LeadsAnnotationsComponent,
        GlobalAnnotationsComponent,
        CustomMeasuresComponent,
        CaliperAndMeasuresComponent,
        EditableCellComponent,
        CaliperMeasuresComponent,
        DateTimePipe,
        SeSpinnerComponent,
        SeFullScreenComponent,
        SeImageButtonComponent,
        SeToggleButtonComponent,
        SeSliderButtonComponent,
        SeStateButtonComponent,
        SeClickOutsideDirective,
        SeSpriteComponent,
        SeComboBoxComponent,
        EcgToolbarComponent,
        EcgSummaryComponent,
        LayoutFabSubToolsComponent,
        LayoutFabToolsComponent,
        SeFabSliderComponent,
        StepComponent,
        TraceComponent,
        WindowComponent,
        PointerComponent,
        CaliperComponent,
        LayersCenteringComponent,
        EcgChartComponent,
        SeCheckedItemComponent,
        SeCheckedListBoxComponent,
        CommonModule,
        FormsModule,
        TranslateModule,
        HotkeyModule,
        MatButtonModule,
        MatRadioModule,
        MatButtonToggleModule,
        MatCardModule,
        MatDatepickerModule,
        MatExpansionModule,
        MatIconModule,
        MatInputModule,
        MatProgressSpinnerModule,
        MatRippleModule,
        MatSelectModule,
        MatTooltipModule,
        MatCheckboxModule,
        MatSliderModule,
        AgGridModule,
        StoreModule.forFeature(fromEcg.key, fromEcg.reducers),
    ],
    exports: [
        EcgViewerComponent,
        EcgToolbarComponent,
        FixedFiltersComponent,
        CaliperAndMeasuresComponent,
        EcgChartComponent,
        SeSpinnerComponent,
        SeCheckedItemComponent,
    ],
})
export class EcgViewerModule {}
